/* ORDERS */
export const GET_INVOICE_HISTORY = "GET_INVOICE_HISTORY"
export const GET_INVOICE_HISTORY_SUCCESS = "GET_INVOICE_HISTORY_SUCCESS"
export const GET_INVOICE_HISTORY_FAIL = "GET_INVOICE_HISTORY_FAIL"


/* GET_INVOICE_HISTORY_DETAIL */
export const GET_INVOICE_HISTORY_DETAIL = "GET_INVOICE_HISTORY_DETAIL"
export const GET_INVOICE_HISTORY_DETAIL_SUCCESS = "GET_INVOICE_HISTORY_DETAIL_SUCCESS"
export const GET_INVOICE_HISTORY_DETAIL_FAIL = "GET_INVOICE_HISTORY_DETAIL_FAIL"

/*  */
export const GET_AUTH_USER = "GET_AUTH_USER"
export const GET_AUTH_USER_FAIL = "GET_AUTH_USER_FAIL"
export const GET_AUTH_USER_SUCCESS = "GET_AUTH_USER_SUCCESS"

/**
 * add ORDER
 */
 export const SET_INVOICE_HISTORY_LOADING = "SET_INVOICE_HISTORY_LOADING"
 export const ADD_NEW_INVOICE_HISTORY = "ADD_NEW_INVOICE_HISTORY"
 export const ADD_INVOICE_HISTORY_SUCCESS = "ADD_INVOICE_HISTORY_SUCCESS"
 export const ADD_INVOICE_HISTORY_FAIL = "ADD_INVOICE_HISTORY_FAIL"
 
 /**
  * Edit ORDER
  */
 export const UPDATE_INVOICE_HISTORY = "UPDATE_INVOICE_HISTORY"
 export const UPDATE_INVOICE_HISTORY_SUCCESS = "UPDATE_INVOICE_HISTORY_SUCCESS"
 export const UPDATE_INVOICE_HISTORY_FAIL = "UPDATE_INVOICE_HISTORY_FAIL"
 
 /**
  * Delete ORDER
  */
 export const DELETE_INVOICE_HISTORY = "DELETE_INVOICE_HISTORY"
 export const DELETE_INVOICE_HISTORY_SUCCESS = "DELETE_INVOICE_HISTORY_SUCCESS"
 export const DELETE_INVOICE_HISTORY_FAIL = "DELETE_INVOICE_HISTORY_FAIL"
 

